var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "crud-form-group",
      class: _vm.validationRules ? _vm.getValidationClass() : ""
    },
    [
      _vm.showLabel
        ? _c("CrudLabel", {
            attrs: {
              label: _vm.label,
              hasCheckBox: _vm.hasCheckBox,
              checkboxData: _vm.checkboxData,
              subLabel: _vm.subLabel,
              classList: _vm.classList
            },
            on: { valueHasChanged: _vm.valueHasChanged }
          })
        : _vm._e(),
      _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue"
              }
            ],
            ref: _vm.id,
            staticClass: "crud-input",
            class: _vm.hasError ? "has-error" : "",
            attrs: {
              id: _vm.id,
              name: _vm.name,
              placeholder: _vm.placeholder,
              "aria-autocomplete": "off",
              autocomplete: "off",
              "aria-placeholder": _vm.placeholder,
              maxlength: _vm.validationRules.max,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.inputValue)
                ? _vm._i(_vm.inputValue, null) > -1
                : _vm.inputValue
            },
            on: {
              focus: _vm.focusIn,
              blur: _vm.focusOut,
              change: function($event) {
                var $$a = _vm.inputValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.inputValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.inputValue = $$c
                }
              }
            }
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue"
              }
            ],
            ref: _vm.id,
            staticClass: "crud-input",
            class: _vm.hasError ? "has-error" : "",
            attrs: {
              id: _vm.id,
              name: _vm.name,
              placeholder: _vm.placeholder,
              "aria-autocomplete": "off",
              autocomplete: "off",
              "aria-placeholder": _vm.placeholder,
              maxlength: _vm.validationRules.max,
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.inputValue, null) },
            on: {
              focus: _vm.focusIn,
              blur: _vm.focusOut,
              change: function($event) {
                _vm.inputValue = null
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue"
              }
            ],
            ref: _vm.id,
            staticClass: "crud-input",
            class: _vm.hasError ? "has-error" : "",
            attrs: {
              id: _vm.id,
              name: _vm.name,
              placeholder: _vm.placeholder,
              "aria-autocomplete": "off",
              autocomplete: "off",
              "aria-placeholder": _vm.placeholder,
              maxlength: _vm.validationRules.max,
              type: _vm.type
            },
            domProps: { value: _vm.inputValue },
            on: {
              focus: _vm.focusIn,
              blur: _vm.focusOut,
              input: function($event) {
                if ($event.target.composing) return
                _vm.inputValue = $event.target.value
              }
            }
          }),
      _vm.errors.length
        ? _c("ErrorList", { attrs: { errors: _vm.errors } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }